export type DyslexiaScreenerDocumentUploadTypeValue =
  | 'TrainingParticipants'
  | 'OtherTrainingPermission'
  | 'SupportingDocuments';

export const DYSLEXIA_SCREENER_DOCUMENT_UPLOAD_OPTIONS: {
  value: DyslexiaScreenerDocumentUploadTypeValue;
  label: string;
}[] = [
  { value: 'TrainingParticipants', label: 'Training Participants' },
  { value: 'OtherTrainingPermission', label: 'Other Training Permission' },
  { value: 'SupportingDocuments', label: 'Supporting Documents' },
];

export const getDyslexiaScreenerDocumentUploadLabel = (
  documentType: string | null | undefined
): string => {
  if (!documentType?.trim()) {
    return '—';
  }
  const match = DYSLEXIA_SCREENER_DOCUMENT_UPLOAD_OPTIONS.find(
    (o) => o.value === documentType
  );
  return match?.label ?? documentType;
};
